import React, { useState, useEffect, useContext } from 'react';

export const ForceMobileContext = React.createContext(false);

const useDocumentWidth = () => {
  const [docWidth, setDocWidth] = useState(null);
  const forceMobile = useContext(ForceMobileContext);

  useEffect(() => {
    const getDocWidth = () => {
      const width = document.documentElement.clientWidth || document.body.clientWidth;
      setDocWidth(width);
    };
    getDocWidth();

    const resizeHandle = () => {
      window.requestAnimationFrame(() => getDocWidth());
    };

    window.addEventListener('resize', resizeHandle);

    return () => {
      window.removeEventListener('resize', resizeHandle);
    };
  }, []);

  if (forceMobile && docWidth != null && docWidth > 768) {
    return 768;
  }
  return docWidth;
};

export default useDocumentWidth;
